import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { connectAsync } from 'iguazu';
import { queryModuleWithData } from 'iguazu-holocron';
import useLangpackLoader from '@americanexpress/one-identity-components/lib/hooks/useLangpackLoader';
import { getShowIdentityUiTwoStepManage } from '../selectors';

const TwoStepManageWrapper = ({
  IdentityUiTwoStepManage,
  OneIdentityTwoStepManage,
  showIdentityUiTwoStepManage,
  loadStatus,
  location,
  route,
}) => {
  useLangpackLoader({ moduleName: 'one-identity-root' });

  if (loadStatus.all !== 'complete') {
    return null;
  }

  return showIdentityUiTwoStepManage
    ? <IdentityUiTwoStepManage location={location} />
    : <OneIdentityTwoStepManage location={location} route={route} />;
};

TwoStepManageWrapper.propTypes = {
  IdentityUiTwoStepManage: PropTypes.func.isRequired,
  OneIdentityTwoStepManage: PropTypes.node.isRequired,
  showIdentityUiTwoStepManage: PropTypes.bool.isRequired,
  loadStatus: PropTypes.shape({
    all: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  route: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
};

export const ComponentToTest = TwoStepManageWrapper;

const loadDataAsProps = ({ store: { dispatch, getState } }) => ({
  IdentityUiTwoStepManage: () => dispatch(queryModuleWithData('identity-ui-two-step-manage')),
  OneIdentityTwoStepManage: () => dispatch(queryModuleWithData('one-identity-two-step-manage')),
  showIdentityUiTwoStepManage: () => ({ status: 'complete', data: getShowIdentityUiTwoStepManage(getState()) }),
});

const hocChain = compose(
  oneAppModuleWrapper(TwoStepManageWrapper),
  connectAsync({ loadDataAsProps })
);

export default hocChain(TwoStepManageWrapper);
